export default {
  "Mold Custom": [
    "Die-casting Mould",
    "Plastic Injection Mould",
    "Stamping Mould",
    {
      "Other Moulds": [
        "Extrusion Mould",
        "Blister Mould",
        "Foam Mould",
        "Forging Mould",
        "Casting Mould",
        "Powder Metallurgy Mould",
        "Glass Mould",
        "Rubber Forming Mould",
        "Ceramic Mould",
        "Drawing Mould",
        "Roller Mould",
        "Economic Mould",
      ],
    },
  ],
  "Mould Batch Products": [
    "Die Casts",
    "Plastic Injection Parts",
    "Stamping Parts",
    {
      "Other Parts": [
        "Extruded Parts",
        "Blister Pieces",
        "Foam Pieces",
        "Forging Parts",
        "Casting Parts",
        "Metallic Sintered Products",
        "Glass Pieces",
        "Rubber Parts",
        "Ceramic Parts",
        "Draw Pieces",
        "Rolled Pieces",
        "Economic Pieces",
      ],
    },
  ],
  "Industrial Products": [
    {
      "Home Applicances": [
        "Dehumidifier",
        "Air-conditioner",
        "Washing Machine",
        "Refrigerator",
        "Wine Cabinet",
      ],
    },
    {
      "Last Mile Delivery Robots": [
        "High Melt Polypropylene",
        "Transport Robot",
        "Sterilization Robot",
        "Guiding Robot",
        "Vending Robot",
      ],
    },
    "RV Campground",
    "Access Control Machine",
    "Mobile Intelligent Diagnosis and Treatment Vehicle",
    "Ambulance",
    "Mobile Medical Detection Shelter",
    "Face Recognition",
    "Smart Temperature Measuring Bracelet",
  ],
  "Epidemic Prevention and Control Supplies": [
    "Smart Temperature Measurement And Disinfection Channel ",
    "Modular Intelligent Medical Isolation Cabin ",
    "Sanitization Channel",
    "Port Epidemic Prevention Compartment",
    "Automatic Disinfecting Robots",
    "Disinfectant Generator",
    "Mercury and Digital Thermometers",
    "Sterilization Products",
    "Protective Clothing",
    "Mask",
    "Mask Machine",
    "Nonwoven Machine",
    {
      "Chemical Products": ["Non-woven Fabric", "Metal Strip", "Tape"],
    },
    {
      "Chemical Raw Materials": [
        "High Melt Polypropylene",
        "Electret Masterbatch",
        "PE Material",
        "Resin",
      ],
    },
  ],
};
